import b1 from './b1'
import b2 from './b2'
import b3 from './b3'
import b4 from './b4'
import b5 from './b5'
import b6 from './b6'
import b7 from './b7'

export const indicadoresEsbConfig = {
  [b1.value]: b1,
  [b2.value]: b2,
  [b3.value]: b3,
  [b4.value]: b4,
  [b5.value]: b5,
  [b6.value]: b6,
  [b7.value]: b7,
}
